import type { PhotoCandid } from '@/api/types/photo'
import {
  PlacementDragGhost,
  type PlacementDragGhostProps,
} from '@/components/app/placement/placement-drag-ghost'

type PhotoDragGhostProps = Omit<PlacementDragGhostProps, 'imageUrl' | 'label'> & {
  photo: PhotoCandid
}

/** `PlacementDragGhost` for a photo — see that file for the positioning and flyback logic. */
export function PhotoDragGhost({ photo, ...ghostProps }: PhotoDragGhostProps) {
  return <PlacementDragGhost imageUrl={photo.urlSqCrop} label={photo.displayName} {...ghostProps} />
}
